import extend from 'extend';
import Q from 'q';
import _ from 'underscore';
import moment from 'moment';

import wait_some_seconds from "nllib/src/common/wait_some_seconds";
import is_null_or_undefined from "nllib/src/common/is_null_or_undefined";
import get_uuid from "nllib/src/common/get_uuid";

const get_payment_channel_entity_list = function (pParameter) {
    if (!pParameter) pParameter = {};

    const wait_seconds = pParameter.wait_seconds || 2;

    const uuid = get_uuid();
    const method_name = `get_payment_channel_entity_list`;

    return Q.when()
        .then(function () {
            console.log(uuid, method_name, `请求接口开始`, pParameter);
            return wait_some_seconds({
                seconds: wait_seconds,
                handler_per_second(args) {
                    const seconds = args.seconds;
                    console.log(uuid, method_name, `等待接口返回中`, `seconds=${seconds}`);
                },
            });
        })
        .then(function () {
            const data = {
                "code": "000000",
                "msg": "成功",
                "paymentChannels": [
                    {
                        "amount": "0.00",
                        "code": 17,
                        "pic": "https://yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/common-project/component/payment-method-selector/icbc-jufutong-b2b-zhifu.png",
                        "text": "工行b2b",
                        "usable": true,
                        serviceFee: `1.00`,
                        realAmount: `11.00`,
                    },
                    {
                        "amount": "0.00",
                        "code": 3,
                        "pic": "https://yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/2020/05/28/qiye-zhifu.png?x-oss-process=style/webp",
                        "text": "企业网银支付",
                        "usable": true,
                        serviceFee: `2.00`,
                        realAmount: `22.00`,
                    },
                    {
                        "amount": "0.00",
                        "code": 9,
                        "pic": "https://yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/2020/05/28/gerenchuxu-zhifu.png?x-oss-process=style/webp",
                        "text": "个人储蓄卡网银支付",
                        "usable": true,
                        serviceFee: `3.00`,
                        realAmount: `33.00`,
                    },
                    {
                        "amount": "0.00",
                        "code": 10,
                        "pic": "https://yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/2020/05/28/gerenxinyongka-zhifu.png?x-oss-process=style/webp",
                        "text": "个人信用卡网银支付",
                        "usable": true,
                        serviceFee: `4.00`,
                        realAmount: `44.00`,
                    },
                    {
                        "amount": "0.00",
                        "code": 5,
                        "pic": "https://yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/common-project/component/payment-method-selector/yibao-zhifu.png",
                        "text": "易宝支付",
                        "usable": true,
                        serviceFee: `5.00`,
                        realAmount: `55.00`,
                    },
                    {
                        "amount": "0.00",
                        "code": 19,
                        "pic": "https://yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/common-project/component/payment-method-selector/weixin-zhifu.png",
                        "text": "工行微信公众号支付",
                        "usable": true,
                        serviceFee: `6.00`,
                        realAmount: `66.00`,
                    },
                    {
                        "amount": "0.00",
                        "code": 20,
                        "pic": "https://yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/common-project/component/payment-method-selector/zhifubao-zhifu.png",
                        "text": "工行支付宝生活号支付",
                        "usable": true,
                        serviceFee: `7.00`,
                        realAmount: `77.00`,
                    }
                ]
            };

            console.log(uuid, method_name, `请求接口结束`, data);

            return Q.resolve(data);
        })
        .catch(function (ex) {
            if (ex) {
                const enable_log_error = !ex.disable_log_error;
                if (enable_log_error) {
                    console.error(ex);
                    console.trace();
                    if (ex.stack) {
                        console.error(ex.stack);
                    }
                }
            }
            return Q.reject(ex);
        })
        ;
};

const pay = function (pParameter) {
    if (!pParameter) pParameter = {};

    const wait_seconds = pParameter.wait_seconds || 2;

    const uuid = get_uuid();
    const method_name = `pay`;

    return Q.when()
        .then(function () {
            console.log(uuid, method_name, `请求接口开始`, pParameter);
            return wait_some_seconds({
                seconds: wait_seconds,
                handler_per_second(args) {
                    const seconds = args.seconds;
                    console.log(uuid, method_name, `等待接口返回中`, `seconds=${seconds}`);
                },
            });
        })
        .then(function () {
            const data = {
                "code": "000000",
                "msg": "成功",
                "htmlStr": "https://cashdesk.yeepay.com/bc-cashier/bccashier/main/10034288923/588137767053",
                "outTradeNo": "588137767053",
                "resultMap": {
                    "WECHAT": "https://ibsbjstar.ccb.com.cn/CCBIS/QR?QRCODE=CCB9980005742018722519724",
                    "ALIPAY": "https://ibsbjstar.ccb.com.cn/CCBIS/QR?QRCODE=CCB9980005731498703218705",
                    "qrcodeUrl": "https://ibsbjstar.ccb.com.cn/CCBIS/QR?QRCODE=CCB9980005731498703218705",
                },
                "second": 0
            };

            console.log(uuid, method_name, `请求接口结束`, data);

            return Q.resolve(data);
        })
        .catch(function (ex) {
            if (ex) {
                const enable_log_error = !ex.disable_log_error;
                if (enable_log_error) {
                    console.error(ex);
                    console.trace();
                    if (ex.stack) {
                        console.error(ex.stack);
                    }
                }
            }
            return Q.reject(ex);
        })
        ;
};

let count_check_payment_status = 0;
const success_count_check_payment_status = 3;

const check_payment_status = function (pParameter) {
    if (!pParameter) pParameter = {};

    const wait_seconds = pParameter.wait_seconds || 2;

    const uuid = get_uuid();
    const method_name = `check_payment_status`;

    return Q.when()
        .then(function () {
            console.log(uuid, method_name, `请求接口开始`, pParameter);
            // return wait_some_seconds({
            //     seconds: wait_seconds,
            //     handler_per_second(args) {
            //         const seconds = args.seconds;
            //         console.log(uuid, method_name, `等待接口返回中`, `seconds=${seconds}`);
            //     },
            // });
        })
        .then(function () {
            count_check_payment_status++;

            const data_001 = {
                "code": "000000",
                "msg": "成功",
                "paymentStatus": 0,
            };

            const data_002 = {
                "code": "000000",
                "msg": "成功",
                "paymentStatus": 2,
            };

            let data;
            if (count_check_payment_status === success_count_check_payment_status) {
                count_check_payment_status = 0;

                data = data_002;
            } else {
                data = data_001;
            }

            console.log(uuid, method_name, `请求接口结束`, data);

            return Q.resolve(data);
        })
        .catch(function (ex) {
            if (ex) {
                const enable_log_error = !ex.disable_log_error;
                if (enable_log_error) {
                    console.error(ex);
                    console.trace();
                    if (ex.stack) {
                        console.error(ex.stack);
                    }
                }
            }
            return Q.reject(ex);
        })
        ;
};

export default {
    get_payment_channel_entity_list,
    pay,
    check_payment_status,
}
